
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProtocolWithProtocolVersionName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProtocolWithProtocolVersionName"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"studyId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cadence"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isPrimary"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customerDefinedId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"versionName"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":195}};
    doc.loc.source = {"body":"fragment ProtocolWithProtocolVersionName on ProtocolWithProtocolVersionName {\n    id,\n    studyId,\n    name,\n    cadence,\n    isPrimary,\n    customerDefinedId,\n    description,\n    versionName\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
